<template>
  <div>
    <div class="ag-form-control">
      <ag-site-and-group
        type="multiple"
        :value="{ label: '', value: groupIds }"
        @change="handleChange($event)"
        @changeOnAllGroup="handleChangeOnAllGroup($event)"
        @siteChange="handleSiteChange($event)"
        :selected-site-data="selectedSite"
        :selected-groups-data="selectedGroups"
        :selected-company-data="selectedCompany"
        ref="siteAndGroupRef"
      />
    </div>

    <div class="ag-form-control">
      <label for="">{{$t("eventId")}}</label>
      <input
        class="w-100 form-control"
        v-model="data.eventId"
        type="text"
        maxlength="50"
        placeholder="Type Event Id"
      />
    </div>
    <div class="ag-form-control" v-if="groupIds.length < 2 || Roles.GroupAdmin">
      <label for="">{{$t("policyversion")}} <small style="font-size:9px">(based on distribution time)</small></label>
      <multiselect
        v-model="data.policyVersion"
        :options="source.policyVersions"
        searchable="true"
        placeholder="Select Policy Version"
        :mode="'multiple'"
        valueProp="id"
      >
        <template v-slot:multiplelabel="{ values }" v-if="type == 'multiple'">
          <div class="multiselect-multiple-label">
            {{ values.length }} version(s) selected
          </div>
        </template>
      </multiselect>
    </div>

    <!-- <div class="ag-form-control">
      <label for="">Membership</label>
      <select
        class="form-select form-select-sm w-100"
        v-model="data.membershipType"
        placeholder="Select a Membership"
      >
        <option value="" disabled selected>Select a Membership</option>
        <option
          v-for="(option, key) in source.membershipType"
          :key="key"
          :value="option"
        >
          {{ option.label }}
        </option>
      </select>
    </div> -->

    <div class="ag-form-control">
      <label for="">{{$t("computerName")}}</label>
      <ag-computer-user-select
        @computerChange="changeComputer"
        @userChange="changeUser"
      />
    </div>

    <div class="ag-form-control">
      <label for="">{{$t("action")}}</label>
      <multiselect
        v-model="data.eventTypeKeyword"
        :options="source.actions"
        searchable="true"
        placeholder="Select Action"
        :mode="'multiple'"
        valueProp="id"
      >
        <template v-slot:multiplelabel="{ values }" v-if="type == 'multiple'">
          <div class="multiselect-multiple-label">
            {{ values.length }} action(s) selected
          </div>
        </template>
      </multiselect>
    </div>

    <div class="ag-form-control">
      <label for="">{{$t("severity")}}</label>
      <multiselect
        v-model="data.severity"
        :options="source.severities"
        searchable="true"
        placeholder="Select Severity"
        :mode="'multiple'"
        valueProp="id"
      >
        <template v-slot:multiplelabel="{ values }" v-if="type == 'multiple'">
          <div class="multiselect-multiple-label">
            {{ values.length }} severity(s) selected
          </div>
        </template>
      </multiselect>
    </div>

    <div class="ag-form-control">
      <label for="">{{$t("actorPath")}} <small style="font-size:9px">(requires full path)</small></label>
      <input
        class="w-100 form-control"
        v-model="data.actorPath"
        type="text"
        maxlength="191"
        placeholder="Type Actor Path"
      />
    </div>

    <div class="ag-form-control">
      <label for="">{{$t("targetPath")}} <small style="font-size:9px">(requires full path)</small></label>
      <input
        class="w-100 form-control"
        v-model="data.targetPath"
        type="text"
        maxlength="191"
        placeholder="Type Target Path"
      />
    </div>

    <!-- <div class="ag-form-control">
      <label for="">Domain Name</label>
      <input
        class="w-100"
        v-model="data.domain"
        type="text"
        placeholder="Type Domain Name"
      />
    </div> -->
  </div>
</template>

<script>
import { Roles } from "@/helpers/enums/Roles";
import AgComputerUserSelect from "./ag-computer-user-select.vue";
import AgSiteAndGroup from "./ag-site-and-group.vue";
import api from "@/store/axiosAgsc";
import Multiselect from "@vueform/multiselect";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    AgComputerUserSelect,
    AgSiteAndGroup,
    Multiselect,
  },
  props: {
    selectedCompanyData: {},
    selectedSiteData: {},
    selectedGroupsData: {},
    value: {
      type: String,
    },
    type: {
      type: String,
      default: "single",
    },
    module: {
      type: Object,
    },
  },
  data() {
    return {
      Roles: Roles,
      groupIds: [],
      data: {
        os: "",
        membershipType: "",
        eventTypeKeyword: [],
        policyVersion: [],
      },
      selectedGroups: [],
      selectedSite: null,
      source: {
        policyVersions: [],
        severities: [
          {
            id: "Lowest",
            label: "Lowest",
            name: "Severity",
          },
          {
            id: "Low",
            label: "Low",
            name: "Severity",
          },
          {
            id: "Medium",
            label: "Medium",
            name: "Severity",
          },
          {
            id: "High",
            label: "High",
            name: "Severity",
          },
          {
            id: "Critical",
            label: "Critical",
            name: "Severity",
          },
        ],
        actions: [
          {
            id: "Process Check",
            label: "Process Check",
            name: "Action",
          },
          // {
          //   id: "File Access",
          //   label: "File Access",
          //   name: "Action",
          // },
          {
            id: "File Write",
            label: "File Write",
            name: "Action",
          },
          {
            id: "File Read",
            label: "File Read",
            name: "Action",
          },
          // {
          //   id: "Registry Access",
          //   label: "Registry Access",
          //   name: "Action",
          // },
          {
            id: "Registry Write",
            label: "Registry Write",
            name: "Action",
          },
          {
            id: "Registry Read",
            label: "Registry Read",
            name: "Action",
          },
          // {
          //   id: "Memory Access",
          //   label: "Memory Access",
          //   name: "Action",
          // },
          {
            id: "Memory Write",
            label: "Memory Write",
            name: "Action",
          },
          {
            id: "Memory Read",
            label: "Memory Read",
            name: "Action",
          },
          {
            id: "Code Load",
            label: "Code Load",
            name: "Action",
          },
          {
            id: "Agent Event",
            label: "Agent Event",
            name: "Action",
          },
        ],
      },
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.$emit("dataChange", this.data);
      },
    },
    group: {
      deep: true,
      handler() {
        this.handleVersionOptions();
      },
    },
    selectedSiteData(value) {
      this.selectedSite = value;
      this.groupIds = [];
    },
    selectedGroupsData(value) {
      this.selectedGroups = value;
    },
    selectedCompanyData(value) {
      this.selectedCompany = value;
    },
  },
  mounted() {
    this.getSource(
      "Defination/GetMembershipTypes",
      "membershipType",
      "membershipTypeName",
      "Membership"
    );
    if (this.group) {
      this.handleVersionOptions();
    }
  },
  computed: {
    ...mapGetters(["loggedInUser", "group"]),
  },
  methods: {
    clearSelectedData(item) {
        const ref = this.$refs.siteAndGroupRef;
        if (item.key in this.data) {
          this.data[item.key] = null;
          this.data[item.selectedLabel] = null;
        } 
        if (item.title == 'Company') {
          ref.clearCompany(item);
        } else if (item.title == 'Site') {
          ref.clearSite(item);
        }
      this.$emit("clearFilter");
    },

    handleChange(e) {
      if (e.type === "group") {
        const filterData = {
          vmodel: [],
          title: "companySiteGroup",
          selectedLabel: "",
          key: "groupIds",
          hide: false,
          type: "siteAndGroup",
          requestKey: "groupIds",
          apiEquivalent: "groupIds",
        };

        this.groupIds = [];
        const filterIndex = this.module.filters.findIndex(
          (i) => i && i.type == "siteAndGroup"
        );

        const groupData = e.data;
        if (groupData && Array.isArray(groupData) && groupData.length) {
          groupData.forEach((element) => {
            filterData.vmodel.push(element.value);
            filterData.selectedLabel =
              (filterData.selectedLabel
                ? filterData.selectedLabel + ", "
                : "") + element.label;
            this.groupIds.push(element.value);
          });
        }else {
          if(filterIndex > -1) {
            this.module.filters[filterIndex].vmodel = '';
            return;
          }
        }

        if (filterIndex > -1) {
          this.module.filters[filterIndex] = filterData;
        } else {
          this.module.filters.push(filterData);
        }
        this.handleVersionOptions();
      } else {
        const filterData = {
          vmodel: e.data.value,
          title: e.data.title,
          selectedLabel: e.data.label,
          key: e.data.key,
          hidden: true,
          type: e.data.title,
          requestKey: e.data.key,
        };

        const filterIndex = this.module.filters.findIndex(
          (i) => i && i.key === e.data.key
        );
        if (filterIndex > -1) {
          this.module.filters[filterIndex] = filterData;
        } else {
          this.module.filters.push(filterData);
        }
      }
    },
    handleChangeOnAllGroup(e) {
      this.handleVersionOptions();
    },
    handleSiteChange(e) {
      this.groupIds = [];
      const filterIndex = this.module.filters.findIndex(
        (i) => i && i.type === "siteAndGroup"
      );
      if (filterIndex > -1) {
        this.module.filters[filterIndex].vmodel = '';
      }
      this.data.computer = null;
    },
    handleVersionOptions() {
      let groupId = null;
      if (this.groupIds && this.groupIds.length > 0) {
        groupId = this.groupIds[0];
      } else if (this.loggedInUser.role == this.Roles.GroupAdmin) {
        groupId = this.group.key;
      }
      if (!groupId) {
        return;
      }
      api
        .get(
          `/Event/GetEventsPolicyFileVersionByGroupGuid?groupGuid=${groupId}`,
          null
        )
        .then((response) => {
          this.source.policyVersions = [];
          if(!response || !response.data) {
            return;
          }
          response.data.forEach((element) => {
            this.source.policyVersions.push({
              id: element.version,
              label: `V ${element.userFriendlyVersion}`,
              name: "Policy Version",
            });
          });
        });
    },
    changeComputer(e) {
      this.data.computer = e.target.value;
    },
    changeUser(e) {
      this.data.user = e;
    },
    getSource(endpoint, data, key, name) {
      api.get(endpoint, null).then((response) => {
        this.source[data] = response.data.entityData.map((i) => {
          return { id: i.id, label: i[key], name: name };
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-form-control {
  margin-bottom: 12px;
}
</style>
